import { apiGetHelper, apiPostHelper } from "../helpers/apiHelper";
import useUserInfo from "../Hooks/useUserInfo";
import { Base_Url } from "./baseurl";




export const IplTeamList = async (category) => {
  try {
    const response = await apiGetHelper("get", `${Base_Url.base_url}/allTeams/${category}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const ChooseFavHateTeam = async (data) => {
  try {
    const response = await apiPostHelper(
      "post",
      `${Base_Url.base_url}/chooseFavandHateTeams`,
      data
    );

    return response;
  } catch (err) {
    console.log(err, "errerr");
  }
};
export const ChooseIplTeamWithCard = async (data) => {

  try {
    const response = await apiPostHelper(
      "post",
      `${Base_Url.base_url}/chooseTeamandCard`,
      data
    );

    return response;
  } catch (err) {
    console.log(err, "errerr");
  }
};

export const MatchScheduleListApi = async (category) => {
  try {
    const response = await apiGetHelper("get", `${Base_Url.base_url}/getMatch/${category}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const QualifierMatchesApi = async (telegramId) => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/getqualifierMatches`
    );
    console.log(response, "response");
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const IplMatchData = async (category) => {

  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/userIplDetails/${category}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const UserIplRunData = async (data) => {
  try {
    const response = await apiPostHelper(
      "post",
      `${Base_Url.base_url}/calculateScores`,
      data,
      "IsError"
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getCurrentBattleScore = async (battleId) => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/getCurrentBattleScores/${battleId}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getPrizePoolDetails = async (teleId, battleId) => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/completedMatchPriceDetails/${battleId}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchOverallTeamPoints = async (category) => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/overAllTeamPointsTable/${category}`,
      "IsError"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching overall team points:", error);
    return null;
  }
};
export const getOverAllPoints = async (category) => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/usersOverAllRunsList/${category}`,
      "IsError"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching overall team points:", error);
    return null;
  }
};
export const getDailyBattleRuns = async (battleId,category) => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/usersDailyBattleRunsList/${battleId}/${category}`,
      "IsError"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching overall team points:", error);
    return null;
  }
};
export const getFavTeamRuns = async (teamId,category) => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/overAllFavTeamPoints/${teamId}/${category}`,
      "IsError"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching overall team points:", error);
    return null;
  }
};

export const CreateSquadApi = async (data) => {
  try {
    const response = await apiPostHelper(
      "post",
      `${Base_Url.base_url}/createSquad`,
      data,
      "IsError"
    );
    return { success: true, data: response?.data };
  } catch (error) {
    console.log(error);

    // Extract error message from the backend response
    const errorMessage =
      error?.response?.data?.message ||
      "Something went wrong. Please try again.";

    return { success: false, error: errorMessage };
  }
};

export const JoinSquadApi = async (data) => {
  try {
    const response = await apiPostHelper(
      "post",
      `${Base_Url.base_url}/joinSquad`,
      data,
      "IsError"
    );
    return { success: true, data: response?.data };
  } catch (error) {
    console.log(error);

    // Extract error message from the backend response
    const errorMessage =
      error?.response?.data?.message ||
      "Something went wrong. Please try again.";

    return { success: false, error: errorMessage };
  }
};
export const UpdateSqaudRunsApi = async (data) => {
  try {
    const response = await apiPostHelper(
      "post",
      `${Base_Url.base_url}/squadRuns`,
      data,
      "IsError"
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const CollegeListForSquadApi = async (telegramId) => {
  try {
    const response = await apiGetHelper("get", `${Base_Url.base_url}/getCollegeleague`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const SquadListApi = async (telegramId) => {
  try {
    const response = await apiGetHelper("get", `${Base_Url.base_url}/getSquad`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const SquadDetails = async (squadId) => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/getUsersquaddetails/${squadId}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const GetIplBoosterList = async (teleId) => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/getIplBoosters`,
      "IsError"
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const purchaseIplBooster = async (data) => {
  try {
    const response = await apiPostHelper(
      "post",
      `${Base_Url.base_url}/purchaseIplBoosters`,
      data,
      "IsError"
    );
    return response.data;
  } catch (err) {
    console.log(err);
  }
};
export const earnRewardInIpl = async (data) => {
  try {
    const response = await apiPostHelper(
      "post",
      `${Base_Url.base_url}/earnBooster`,
      data
    );
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const unClaimedBoosterList = async (category) => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/unclaimedBoosterList`,
      "IsError"
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ClaimRewardIpl = async (data) => {
  try {
    const response = await apiPostHelper(
      "post",
      `${Base_Url.base_url}/claimBooster`,
      data
    );
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const fanRallyApi = async (data) => {
  try {
    const response = await apiPostHelper(
      "post",
      `${Base_Url.base_url}/fanRally`,
      data,
      "IsError"
    );
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const ClaimedBoosterList = async (category) => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/getClaimedBoostersList`,
      "IsError"
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const QuizQuestionsApi = async (teleId) => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/getQuizzes`,
      "IsError"
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const topOverAllLeagueLeaderboard = async () => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/topOverAllLeagueLeaderboard`,
      "IsError"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching squad leaderboard:", error);
    return null;
  }
};

export const topClgLeagueLeaderboard = async () => {
  try {
    const response = await apiGetHelper(
      "get",
      `${Base_Url.base_url}/topClgLeagueLeaderboard`,
      "IsError"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching college leaderboard:", error);
    return null;
  }
};

  export const CreateSquadChat = async (data) => {
    
    try {
      const response = await apiPostHelper("post",
        `${Base_Url.base_url}/createGroup`,
        data,
        "IsError",
      );
      return response.data;
    } catch (err) {
      console.log(err);
    }
  };
